import { APIParser } from "./api-parser";
import { NEW_API_URL } from "./api-client";
import { createURLWithQueryParams, getToken } from "./api-util";
import triyoAPI from "./triyo";
import { config } from "../../util/axios-config";

const baseRolePrivilegesURL = `${NEW_API_URL}`;

export const GetRolePrivilege = async (id) => {
  if (!id) {
    throw new Error("GetRolePrivilege requires an id");
  }

  const url = createURLWithQueryParams(
    `${baseRolePrivilegesURL}/role-privileges`,
    { id }
  );

  try {
    const response = await triyoAPI.get(url, config());
    return response.data;
  } catch (err) {
    console.error("Error fetching role privilege for id=", id, err);
    throw err;
  }
};

export const GetRolePrivilegeLegacy = async (id) => {
  const url = createURLWithQueryParams(
    `${baseRolePrivilegesURL}role-privileges/`,
    { id }
  );
  let token = getToken();
  if (token) {
    return fetch(url, {
      method: "GET",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => APIParser(response));
  } else {
    throw new Error("Token didn't worked!");
  }
}

export const EditRolePrivilege = async (rolePrivilege) => {
  let rolePrivilegeJson = JSON.stringify(rolePrivilege);
  const url = createURLWithQueryParams(
    `${baseRolePrivilegesURL}edit-role-privilege`
  );
  let token = getToken();
  if (token) {
    return fetch(url, {
      method: "POST",
      credentials: "include",
      body: rolePrivilegeJson,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => APIParser(response));
  } else {
    throw new Error("Token didn't worked!");
  }
}

export const FixRolePrivileges = async () => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization",`Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(
    NEW_API_URL + "role-privileges/FixRolePrivileges",
    requestOptions
  );
}